// @ts-nocheck
import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    setFullPageLayout: ['payload'],
    setStep: ['payload'],
    addFile: ['payload'],
    removeFile: null,
    setColumnsAndRows: ['payload'],

    getSystemFieldsRequest: ['params'],
    getSystemFieldsSuccess: ['payload'],
    getSystemFieldsFailure: null,

    matchColumn: ['payload'],
    unmatchColumn: ['payload'],
    reset: null,

    checkUnidentifiedCostCodesRequest: ['params', 'payload'],
    checkUnidentifiedCostCodesSuccess: ['payload'],
    checkUnidentifiedCostCodesFailure: ['payload'],

    checkDefaultCostCodeRequest: null,
    checkDefaultCostCodeSuccess: ['payload'],
    checkDefaultCostCodeFailure: null,

    saveBulkResourceCodesRequest: ['params', 'payload'],
    saveBulkResourceCodesRequestEmp: ['params', 'payload'],
    saveBulkResourceCodesSuccess: ['payload'],
    saveBulkResourceCodesFailure: null,

    setImportUnmatchedColumns: ['payload'],
    setImportUnidentifiedCostCodes: ['payload'],

    removeDuplicateRows: null,
    removeEmptyMandatoryFields: null,
    addSystemField: ['payload'],
  },
  { prefix: 'RESOURCE_CODE_IMPORT/' },
);

export default Creators;
